<template>
  <div class="company-segment">
    <!-- Management / multi-account: reuse the existing dropdown as-is. -->
    <company-dropdown
      v-if="canSwitchCompany"
      :user="user"
    />

    <!-- Everyone else: plain label for breadcrumb consistency. -->
    <span v-else class="company-label" :title="companyName">
      <v-icon small color="bg_force_white" class="company-icon">mdi-domain</v-icon>
      <span class="text-truncate company-name">{{ companyName }}</span>
    </span>
  </div>
</template>

<script>
import CompanyDropdown from '@/features/Company/components/CompanyDropdown.vue';
import { CompanyType } from '@/features/Share/config/enums';
import permissions from '@/features/Share/config/permissions';
import { userHasPermissions } from '@/utils/permissionRule';

export default {
  name: 'CompanySegment',
  components: { CompanyDropdown },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMultiAccountMode() {
      return this.$store.getters['ACCOUNT/IS_MULTI_ACCOUNT_MODE'];
    },
    canSwitchCompany() {
      return !!(
        this.user
        && this.user.company
        && (this.isMultiAccountMode || (
          this.user.company.companyType === CompanyType.Management
          && userHasPermissions(this.user, permissions.CompaniesManagement.Impersonate)
        ))
      );
    },
    companyName() {
      return (this.user && this.user.company && this.user.company.name) || 'My Company';
    },
  },
};
</script>

<style lang="scss" scoped>
.company-segment {
  display: inline-flex;
  align-items: center;
}

.company-label {
  display: inline-flex;
  align-items: center;
  color: var(--v-bg_force_white-base);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  padding: 0 8px;
  height: 20px;
  cursor: default;
  user-select: none;
}

.company-icon {
  margin-right: 12px;
}

.company-name {
  max-width: 180px;
  display: inline-block;
  vertical-align: middle;
}

@media (max-width: 600px) {
  .company-name {
    max-width: 120px;
  }
}
</style>
